import request from '@/utils/request';

// 帮助列表
export default async function getHelpList(params) {
  return request.get('nxin.information.help.list/1.0', {
    params,
  });
}
